import { PAYMENT_STATUS_REPORT } from 'actions/dataReport';

const initialState = {
  isLoading: false,
  paymentStatusReports: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const paymentStatusReportReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case PAYMENT_STATUS_REPORT.REQUEST: {
      return { ...state, isLoading: true };
    }

    case PAYMENT_STATUS_REPORT.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        paymentStatusReports: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case PAYMENT_STATUS_REPORT.FAIL: {
      return { ...state, isLoading: false };
    }

    default:
      return { ...state };
  }
};
export default paymentStatusReportReducer;
